import { Components } from "@mui/material";
import { grey } from "../palette";

export const MuiTableHead: Components["MuiTableHead"] = {
  styleOverrides: {
    root: {
      backgroundColor: "#fff",
      "&:hover": {
        backgroundColor: "#fff",
      },
      th: {
        color: grey[600],
        fontSize: "0.7rem",
        fontWeight: 900,
      },
    },
  },
};

export const MuiTableCell: Components["MuiTableCell"] = {
  styleOverrides: {
    root: {
      fontSize: "12px",
      lineHeight: "20px",
      fontWeight: 400,
      borderBottom: `1px solid ${grey[50]}`,
    },
  },
};

export const MuiTableRow: Components["MuiTableRow"] = {
  styleOverrides: {
    root: {
      "&:selected": {
        backgroundColor: grey[50],
      },
      "&:hover": {
        backgroundColor: grey[50],
      },
    },
  },
};
